import {
  CACHED_ORDER_PREFIX,
  useSearchPublicOrder,
} from "@babackapp/private-api-client/client/use-search-public-order";

export function useSearchOrder() {
  const mutation = useSearchPublicOrder();

  return {
    ...mutation,
    mutateAsync: async (...args: Parameters<typeof mutation.mutateAsync>) => {
      const data = await mutation.mutateAsync(...args);
      // Persist to localStorage so usePublicOrder can read it after iframe reloads
      try {
        localStorage.setItem(
          `${CACHED_ORDER_PREFIX}-${data.orderId}`,
          JSON.stringify(data),
        );
      } catch {
        // ignore storage errors
      }
      return data;
    },
  };
}
